export * from './percentage.component';
